import React, { useState } from 'react';

import { faPlugCircleXmark } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';
import confirm from 'components/confirm';
import { deleteRequest } from 'helpers/api';
import { showSnackbar } from 'components/ui/snackbar/helper';

interface Props {
  destroyPath: string;
  variant?: 'destructive' | 'ghost';
  onDestroy: () => void;
}

export default function DisconnectNylasGrant({ destroyPath, variant = 'ghost', onDestroy }: Props) {
  const [destroying, setDestroying] = useState(false);

  async function destroy() {
    try {
      await confirm('Are you sure you want to disconnect this integration?', {
        buttonLabel: 'Disconnect',
        buttonStyle: 'danger',
        title: 'Disconnect Integration',
      });
    } catch (e) {
      return;
    }

    try {
      setDestroying(true);
      await deleteRequest(destroyPath);
    } catch (e) {
      showSnackbar({ text: 'Something went wrong.', variant: 'danger' });
      return;
    } finally {
      setDestroying(false);
    }

    onDestroy();
  }

  return <>
    <Button disabled={destroying} icon={faPlugCircleXmark} label="Disconnect" variant={variant} onClick={destroy} />
  </>;
}
